import React, { useMemo } from "react";
import { InputComponent } from "../input-types";
import { getDataset, getInputCss, getInputSettings } from "../input-utility";

type Props = {
  checked?: boolean;
  text?: string;
  className?: string;
  error?: string | boolean;
};

export const Checkbox: InputComponent<HTMLInputElement, Props> = (
  props: Props,
) => {
  const css = getInputCss(props.error, "c-form-check", props.className);
  const dataset = useMemo(() => getDataset(props), [props]);
  const inputSettings = getInputSettings(props);

  return (
    <label className={css}>
      <input
        type="checkbox"
        {...dataset}
        {...inputSettings}
        checked={props.checked}
      />
      <i className="c-form-check__mimic" />
      {props.text}
    </label>
  );
};
